import { useRef, useState } from "react";
import {
  Autocomplete,
  Button,
  Divider,
  Grid,
  MaskedInput,
  TextareaAutosize,
  TextField,
  Tooltip,
  Typography,
} from "../../../../../components";
import "./informacoes.styles.css";
import { responseErros, timeoutBuscaAutocomplete } from "../../../../../utils";
import { PessoaService } from "../../../../../services";
import IntermediadorDialog from "../dialogComponents/intermediador-dialog.component";

const NfSaidaInformacoes = ({
  nfSaidaId,
  nfSaidaEntity,
  setNfSaida,
  intermediadorSelecionado,
  setIntermediadorSelecionado,
  handleInputChange,
}) => {

  const inputRef = useRef();
  const [intermediadores, setIntermediadores] = useState([]);
  const [loadingAutoComplete, setLoadingAutoComplete] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [infoDialog, setInfoDialog] = useState({});
  const [editarIntermediador, setEditarIntermediador] = useState(false);
  const pessoaService = new PessoaService();

  const buscaPessoas = async function (filter) {
    const result = await pessoaService.getAll(filter);
    if (!result.isAxiosError) {
      setIntermediadores(result.data.rows);
      setLoadingAutoComplete(false);
    } else {
      responseErros(result);
    }
  };

  const onInputChangeAutocomplete = (event) => {
    if (event.key === "Enter" && inputRef.current === document.activeElement) {
      const eventValue = event.target?.value;
      if (eventValue?.length >= 2) {
        const filtros = {
          nomeRazaoSocial: eventValue,
          naturezaSocial: 'juridica',
          restritiva: true
        };
        setLoadingAutoComplete(true);
        timeoutBuscaAutocomplete(buscaPessoas(filtros));
      }
    }
  };

  const onChangeAutocomplete = (value) => {
    let nomeRazaoSocial = null, cnpjCpf = null;
    if (value) {
      nomeRazaoSocial = value.nomeRazaoSocial;
      cnpjCpf = value.cnpjCpf;
    }

    nfSaidaEntity.setIdentificarIntermediador({ nomeRazaoSocial, cnpjCpf });
    setNfSaida((prevState) => ({ ...prevState, nfSaidaEntity }));
    setIntermediadorSelecionado(value);
    setInfoDialog({});
    setEditarIntermediador(false);
  };

  return (
    <>
    <Typography variant="body2" gutterBottom sx={{ mb: 2 }}>
      {" "}
      Identificação do Intermediador
    </Typography>
    <Grid container spacing={2}>
      <Grid item xs={5.75}>
        <Autocomplete
          id="intermediadorRazaoSocial"
          name="intermediadorRazaoSocial"
          options={intermediadores}
          noOptionsText="Digite e pressione Enter"
          autoHighlight
          loading={loadingAutoComplete}
          loadingText="Carregando"
          getOptionLabel={(option) => (option ? option.nomeRazaoSocial : "")}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Razão Social"
              variant="outlined"
              onKeyDown={(e) => onInputChangeAutocomplete(e)}
              inputRef={inputRef}
              InputProps={{
                ...params.InputProps,
              }}
            />
          )}
          onChange={(_, newValue) => onChangeAutocomplete(newValue)}
          value={intermediadorSelecionado}
        />
      </Grid>
      <Grid
        item
        xs={0.5}
        className="d-flex justify-content-center align-items-center"
      >
        <Tooltip
          title={
            editarIntermediador
              ? "Editar Intermediador"
              : "Adicionar Intermediador"
          }
          arrow
          placement="bottom"
        >
          <Button
            id="buttonAdicionarIntermediador"
            variant="contained"
            size="small"
            sx={{
              height: "35px",
              borderRadius: "20%",
              minWidth: "15px",
              boxShadow: "none",
            }}
            onClick={() => setOpenDialog(true)}
          >
            <i
              className={
                editarIntermediador ? "ph-bold ph-pencil" : "ph-bold ph-plus"
              }
              style={{ color: "#fff", fontSize: 15 }}
            ></i>
          </Button>
        </Tooltip>
      </Grid>
      <Grid item xs={5.75}>
        <MaskedInput
          id="intermediadorCnpj"
          label={"CNPJ"}
          name="intermediadorCnpj"
          variant="outlined"
          margin="none"
          disabled
          mask={"**.***.***/****-99"}
          value={intermediadorSelecionado?.cnpjCpf ?? ""}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
    </Grid>
    <Divider sx={{ mt: 2, border: "1px solid grey", width: "100%" }} />
    <Typography variant="body2" gutterBottom sx={{ mb: 2, mt: 2}}>
      {" "}
      Informações complementares
    </Typography>
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <TextareaAutosize
          className="text-area w-100 p-3"
          aria-label="minimum height"
          name="informacoesAdicionais"
          id="informacoesAdicionais"
          disabled={nfSaidaId}
          onChange={handleInputChange}
          value={nfSaidaEntity?.informacoesAdicionais}
          minRows={5}
          placeholder="Informações adicionais"
        />
      </Grid>
      <Grid item xs={6}>
        <TextareaAutosize
          className="text-area w-100 p-3"
          aria-label="minimum height"
          name="informacoesFisco"
          id="informacoesFisco"
          disabled={nfSaidaId}
          onChange={handleInputChange}
          value={nfSaidaEntity?.informacoesFisco}
          minRows={5}
          placeholder="Informações fisco"
        />
      </Grid>
    </Grid>
    <IntermediadorDialog
      open={openDialog}
      setOpen={setOpenDialog}
      infoDialog={infoDialog}
      setInfoDialog={setInfoDialog}
      setIntermediadorSelecionado={setIntermediadorSelecionado}
      nfSaidaEntity={nfSaidaEntity}
      setNfSaida={setNfSaida}
      setIntermediadores={setIntermediadores}
      setEditarIntermediador={setEditarIntermediador}
    />
    </>
  );
};

export default NfSaidaInformacoes;
